export default function Library() {
  return (
    <div className="min-h-screen bg-[#E8E4DC] font-mono">
      {/* Background Effects */}
      <div className="fixed inset-0 opacity-[0.03] pointer-events-none"></div>
      <div className="fixed inset-0 opacity-[0.08] pointer-events-none">
        <div className="absolute top-[-10%] left-[-5%] w-[600px] h-[600px] rounded-[40%_60%_70%_30%/60%_30%_70%_40%] bg-gradient-radial from-[#4A4A4A] via-[#6A6A6A] to-[#8A8A8A] blur-[100px] animate-pulse"></div>
        <div className="absolute top-[10%] right-[-10%] w-[550px] h-[550px] rounded-[60%_40%_30%_70%/40%_60%_70%_30%] bg-gradient-radial from-[#5A5A5A] via-[#7A7A7A] to-[#4A4A4A] blur-[100px] animate-pulse"></div>
        <div className="absolute bottom-[-15%] left-[20%] w-[650px] h-[650px] rounded-[30%_70%_70%_30%/30%_30%_70%_70%] bg-gradient-radial from-[#6A6A6A] via-[#4A4A4A] to-[#5A5A5A] blur-[100px] animate-pulse"></div>
      </div>

      <div className="relative">
        {/* Hero Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-[64px] md:text-[96px] font-black leading-none tracking-tight text-[#4A4A4A] mb-6">
                LEGAL LIBRARY
              </h1>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto mb-8">
                Comprehensive collection of legal documents, contracts, and resources
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a href="/" className="inline-block bg-[#4A4A4A] text-white px-6 py-3 text-sm font-bold hover:opacity-80 transition-opacity whitespace-nowrap cursor-pointer">
                  ← BACK TO HOME
                </a>
                <a href="/blog" className="inline-block bg-teal-600 text-white px-6 py-3 text-sm font-bold border-2 border-dashed border-[#4A4A4A] hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                  BLOG POSTS
                </a>
                <a href="/legal-services" className="inline-block bg-emerald-600 text-white px-6 py-3 text-sm font-bold border-2 border-dashed border-[#4A4A4A] hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer">
                  LEGAL AARON AI
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* GAMMA SOURCE — Celebrated Fish Deck */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-white/20">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                GAMMA SOURCE — CELEBRATED FISH DECK
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
            </div>

            <div className="bg-white/60 border-4 border-dashed border-[#4A4A4A] p-8 max-w-[1000px] mx-auto">
              <div className="mb-6">
                <p className="text-sm font-bold text-[#4A4A4A] mb-2">SOURCE URL:</p>
                <p className="text-sm text-[#4A4A4A] break-all">https://celebrated-fish-l6j1w1v.gamma.site/</p>
              </div>

              <div className="mb-6">
                <p className="text-sm font-bold text-[#4A4A4A] mb-2">STATUS:</p>
                <p className="text-sm text-amber-600 font-bold">PENDING MANUAL PASTE</p>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-bold text-[#4A4A4A] mb-3">
                  CONTENT CONTAINER: PASTE FULL EXTRACTED TEXT HERE (DO NOT SUMMARIZE)
                </label>
                <textarea 
                  className="w-full h-[600px] p-4 border-2 border-dashed border-[#4A4A4A] bg-white/80 text-[#4A4A4A] text-sm font-mono resize-none focus:outline-none focus:border-teal-600"
                  placeholder="Paste the full extracted text content here..."
                ></textarea>
              </div>

              <div className="text-center pt-4 border-t-2 border-dashed border-[#4A4A4A]">
                <p className="text-xs text-[#4A4A4A] font-bold">
                  END OF FULL SOURCE INGEST — celebrated-fish-l6j1w1v.gamma.site (pending)
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Authorization Document Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-white/20">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                AUTHORIZATION DOCUMENT
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
            </div>

            <div className="bg-white/60 border-4 border-dashed border-[#4A4A4A] p-8 max-w-[900px] mx-auto">
              <div className="prose prose-sm max-w-none text-[#4A4A4A] leading-relaxed" dir="rtl">
                <p className="mb-4">إنه في يوم الموافق من شهر عام ألفان</p>
                <p className="mb-4">أمامنا نحن الموقع الإلكتروني القانوني الشامل</p>
                <p className="mb-4">حضــــر السيد/ - مصري الجنسية – والمقيم في: ---------------------------.</p>
                <p className="mb-4">وقرر توكيل الموقع بما يلي:</p>
                
                <h3 className="text-xl font-bold mt-6 mb-3">أولاً: في تحميل العقود والاتفاقيات:</h3>
                <p className="mb-4">
                  لقد وكل السيد/ زائر الموقع هذا الموقع ليكون المصدر الأول والأمثل لتحميل كافة نماذج العقود والاتفاقيات القانونية، التي تم إعدادها بدقة باللغتين العربية والإنجليزية، وتغطي مختلف المجالات القانونية التي قد يحتاجها المستخدم. ويشمل ذلك العقود العرفية والرسمية، واتفاقيات البيع والشراء، والشراكات التجارية، والعقود المتعلقة بالملكية الفكرية، وأي نماذج أخرى يمكن أن تخدم المتطلبات القانونية للمستخدم.
                </p>

                <h3 className="text-xl font-bold mt-6 mb-3">ثانياً: في الوصول إلى الكتب والمراجع القانونية:</h3>
                <p className="mb-4">
                  وكل السيد/ - زائر الموقع الموقع ليتيح له الوصول إلى مكتبة قانونية شاملة تحتوي على مجموعة واسعة من الكتب القانونية، والأبحاث، والمراجع التي تغطي جميع فروع القانون. وتشمل هذه المراجع القانون المدني، والقانون الجنائي، وقانون الأحوال الشخصية، والقانون التجاري، وغيرها من التخصصات القانونية. كما يوفر الموقع إمكانية تحميل هذه الكتب والأبحاث للاطلاع عليها في أي وقت.
                </p>

                <h3 className="text-xl font-bold mt-6 mb-3">ثالثاً: في إضافة وتوسيع المحتوى القانوني:</h3>
                <p className="mb-4">
                  لقد أذن السيد/ ----------------------- للموقع بتمكينه من إضافة محتويات قانونية جديدة، سواء كانت نماذج عقود، أو أبحاث، أو مراجع أخرى، بما يساهم في إثراء المكتبة القانونية الموجودة على الموقع. ويشمل هذا أيضًا تحديث المحتويات الموجودة لتتوافق مع أحدث التعديلات القانونية والتشريعات الجديدة، مما يضمن حصول المستخدم على معلومات دقيقة وحديثة.
                </p>

                <h3 className="text-xl font-bold mt-6 mb-3">رابعاً: في تيسير الوصول والدعم الفني:</h3>
                <p className="mb-4">
                  كما وكل السيد/ ----------------------- الموقع لتقديم الدعم الفني المستمر الذي يضمن سهولة الوصول إلى جميع المحتويات والخدمات المقدمة، وتقديم المساعدة في حالة وجود أي استفسارات أو مشكلات تقنية. ويشمل هذا الدعم إمكانية التواصل مع فريق الموقع للحصول على توضيحات أو مشورات قانونية مبسطة حول كيفية استخدام المحتويات.
                </p>

                <h3 className="text-xl font-bold mt-6 mb-3">خامساً: في توسيع قاعدة المستخدمين ونشر المعرفة:</h3>
                <p className="mb-4">
                  وكل السيد/ ----------------------- الموقع بتوسيع قاعدة المستخدمين من خلال إتاحة إمكانية مشاركة الروابط الخاصة بالمحتويات القانونية مع الآخرين، سواء كانوا أفرادًا أو مؤسسات، مما يسهم في نشر المعرفة القانونية على نطاق أوسع. كما يمكن للمستخدمين تقديم التوصيات والإضافات التي يرونها مفيدة للمحتوى القانوني.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Video Resources Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                VIDEO RESOURCES
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
            </div>

            <div className="max-w-[900px] mx-auto">
              <div className="bg-white/60 border-4 border-dashed border-[#4A4A4A] p-4">
                <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                  <iframe 
                    src="https://www.youtube.com/embed/Lifklp2sHhs" 
                    className="absolute top-0 left-0 w-full h-full"
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen
                    title="Elhawary Brothers"
                  ></iframe>
                </div>
                <div className="mt-4 p-4 bg-amber-50/50 border-2 border-dashed border-amber-600">
                  <h3 className="font-bold text-[#4A4A4A] mb-2">Elhawary Brothers</h3>
                  <p className="text-sm text-[#4A4A4A]">Introduction to our legal services</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Legal Categories Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-white/20">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                LEGAL DOCUMENT CATEGORIES
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">
                Browse our comprehensive collection of legal documents and resources
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {/* Lawsuits */}
              <a href="https://www.playbook.com/s/hawary/yCSrAkhftx5KVD9JUQfBa1ck" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-text-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">صيغ الدعاوى</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Lawsuit Forms</p>
              </a>

              {/* Defense Memoranda */}
              <a href="https://www.playbook.com/s/hawary/WPgWvXH2yJiuv1Xc51Gvpsmr" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">مذكرات دفاع</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Defense Memoranda</p>
              </a>

              {/* Contract Forms */}
              <a href="https://www.playbook.com/s/hawary/ZgUyemCeJHe9pnVhQW24YaV6" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-list-3-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">صيغ العقود</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Contract Forms</p>
              </a>

              {/* Electronic & Communications Contracts */}
              <a href="https://www.playbook.com/s/hawary/frDzwUYSbt1Ltb3sKQLxg1y6" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-smartphone-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">عقود الكترونية و الأتصالات</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Electronic & Communications Contracts</p>
              </a>

              {/* Criminal Procedures */}
              <div className="bg-white/60 border-4 border-dashed border-red-600 p-6">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-police-badge-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2">الأجراءات الجنائية</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Criminal Procedures</p>
              </div>

              {/* Narcotics */}
              <div className="bg-white/60 border-4 border-dashed border-red-600 p-6">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-medicine-bottle-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2">مخدرات</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Narcotics Law</p>
              </div>

              {/* Building Licenses 2024 */}
              <a href="https://datafactory.my.canva.site/dagpqvidjp0" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-building-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">أجرأءات تراخيص البناء الجديدة 2024</h3>
                <p className="text-sm text-[#4A4A4A] text-center">New Building Licenses Procedures 2024</p>
              </a>

              {/* Fraud Crime */}
              <a href="https://www.playbook.com/s/hawary/BuyMnR3C8nUK2pFipmoq97Rt" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-error-warning-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">جريمة النصب</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Fraud Crime</p>
              </a>

              {/* UAE Laws */}
              <a href="https://www.playbook.com/s/hawary/2yGeMJcFHTEfanHWNXkTTvj5" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-government-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">قوانين الأمارات</h3>
                <p className="text-sm text-[#4A4A4A] text-center">UAE Laws</p>
              </a>

              {/* Court of Cassation Rulings */}
              <a href="https://www.playbook.com/s/hawary/6PqUBF56wgamE1JCw9wdcxhf" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-scales-3-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">أحكام النقض</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Court of Cassation Rulings</p>
              </a>

              {/* Under Training */}
              <a href="https://www.playbook.com/s/hawary/Nr1Srmy53qdSXetwWNJKZFhq" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-book-open-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">تحت التمرين</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Under Training</p>
              </a>

              {/* Forensic Medicine */}
              <a href="https://www.playbook.com/s/hawary/JxRMHeiccw5716kUi68onMA6" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-microscope-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">طب شرعى</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Forensic Medicine</p>
              </a>

              {/* Saudi Laws */}
              <a href="https://www.playbook.com/s/hawary/ekghBRJYzNrihWBBXJgA9bFo" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-government-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">قوانين سعودية</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Saudi Laws</p>
              </a>

              {/* Legal Practice Harvest */}
              <a href="https://www.playbook.com/s/hawary/35Jm1uTFASTHA8vPGiewrEK5" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-briefcase-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">حصاد المحاماه</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Legal Practice Harvest</p>
              </a>

              {/* Religious Books */}
              <a href="https://www.playbook.com/s/hawary/jYDSiZSG3cMpEcUJdzBuEcF3" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-book-2-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">كتب دينية</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Religious Books</p>
              </a>

              {/* English/Arabic Legal Translations */}
              <a href="https://www.playbook.com/s/hawary/yoVuxfJNyw2QvJoF5VkX8Q1z" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-translate-2 text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">English / Arabic legal translations</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Legal Translation Services</p>
              </a>

              {/* Contracts and Agreements */}
              <a href="https://www.playbook.com/s/hawary/6ZJFRn1zpcBa4z1AaicELLwZ" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-text-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">Contracts and Agreements</h3>
                <p className="text-sm text-[#4A4A4A] text-center">English Contracts & Agreements</p>
              </a>

              {/* Tesla Contracts */}
              <a href="https://www.playbook.com/s/hawary/6PeYyz4SuFc4Ps3PGe7o8eau" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-car-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">Tesla Contracts</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Tesla Legal Documents</p>
              </a>

              {/* Debt Consolidation */}
              <a href="https://jmp.sh/1u1R9hDT" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-money-dollar-circle-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">All about Debt Consolidation</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Debt Consolidation Guide</p>
              </a>

              {/* Egyptian Government Contracts */}
              <a href="https://www.playbook.com/s/hawary/oYwMBwb8H8xw6rRg1XyPkGAR" target="_blank" rel="noopener noreferrer" className="bg-white/60 border-4 border-dashed border-red-600 p-6 hover:bg-white/80 transition-colors cursor-pointer group">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-government-line text-5xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] text-center mb-2 group-hover:text-red-600 transition-colors">Egyptian Government contracts</h3>
                <p className="text-sm text-[#4A4A4A] text-center">Government Contract Templates</p>
              </a>
            </div>
          </div>
        </section>

        {/* Appointment Booking Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                SCHEDULE A CONSULTATION
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto mb-8">
                Book an appointment for your legal service consultation
              </p>
            </div>

            <div className="bg-white/60 border-4 border-dashed border-[#4A4A4A] p-4 max-w-[1000px] mx-auto">
              <iframe 
                src="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ05QjB_-chnvotVqPcQ8_UKIYd1pKVkBIzqmK8ADyQPWXo_q_JYs5nhflt-zKZI9hw-V45RzQmb" 
                className="w-full h-[800px]"
                frameBorder="0"
                title="Appointment Booking"
              ></iframe>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-teal-600/90 to-teal-700/90">
          <div className="max-w-[900px] mx-auto text-center">
            <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-white mb-6">NEED LEGAL ASSISTANCE?</h2>
            <p className="text-xl text-white/90 mb-8 max-w-[700px] mx-auto">
              Access our comprehensive legal library or contact us for personalized legal services
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="mailto:elhawarybrothersllc@gmail.com" className="inline-block bg-amber-600 text-white px-8 py-4 text-lg font-bold border-2 border-dashed border-white hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer">
                CONTACT US
              </a>
              <a href="/" className="inline-block bg-transparent border-2 border-dashed border-white text-white px-8 py-4 text-lg font-bold hover:bg-white hover:text-[#4A4A4A] transition-colors whitespace-nowrap cursor-pointer">
                BACK TO HOME
              </a>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="px-6 py-12 bg-stone-800 text-stone-200">
          <div className="max-w-[1200px] mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
              <div className="col-span-1 md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <img 
                    alt="Elhawary Brothers LLC" 
                    className="h-12 w-12" 
                    src="https://aaronai.my.canva.site/we-re-elhawary-brothers-for-legal-service-always-available-to-answer-your-questions-review-contracts-and-help-you-with-anything-on-your-mind/images/6d56202f5cc6c783dbd3ce2db48c755d.png" 
                  />
                  <span className="text-xl font-bold">Elhawary Brothers LLC</span>
                </div>
                <p className="text-stone-400 mb-4 max-w-md text-sm">
                  Comprehensive legal library and professional legal services for all your needs.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-bold mb-4 text-white">Quick Links</h3>
                <ul className="space-y-2 text-sm">
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="/">Home</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="/blog">Blog Posts</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="/legal-services">Legal Aaron AI</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="/library">Legal Library</a></li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-bold mb-4 text-white">Contact Info</h3>
                <ul className="space-y-3 text-stone-400 text-sm">
                  <li className="flex items-start space-x-2">
                    <i className="ri-map-pin-line text-amber-500 mt-1"></i>
                    <span>Alexandria, Egypt</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-phone-line text-amber-500 mt-1"></i>
                    <span>+201000867697</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-mail-line text-amber-500 mt-1"></i>
                    <span>elhawarybrothersllc@gmail.com</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="border-t border-dashed border-stone-700 pt-8 flex flex-col md:flex-row justify-between items-center">
              <p className="text-stone-400 text-xs mb-4 md:mb-0">© 2025 Elhawary Brothers LLC. All rights reserved.</p>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-stone-400 hover:text-amber-500 text-xs transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
